// 应用下载相关逻辑：根据设备/厂商跳转到对应的下载链接

export const downloadLinks = {
    ios: 'https://apps.apple.com/cn/app/%E6%97%8F%E8%AF%AD/id6751788359',
    xiaomi: 'https://m.malink.cn/s/ZJRnuu',
    vivo: 'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=4449732&resource=301&source=7',
    honor: 'https://appmarket-h5.cloud.honor.com/h5/share/latest/index.html?shareId=2080910362813841408&shareTo=copyLink',
    oppo: 'https://m.malink.cn/s/ZJRnuu',
    harmony: 'https://appgallery.huawei.com/app/detail?id=com.zuji.sayfamily&channelId=SHARE&source=appshare',
};

// iOS：优先尝试唤起 App，失败则跳转 App Store
export const iosScheme = 'zuyuapp://open';

export const isWeChat = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
};

export const isIos = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod');
};

// 打开 App Store（兼容微信内置浏览器）
const openAppStore = () => {
    const url = downloadLinks.ios;
    // 微信里用 location.replace / a 标签跳转，比直接改 href 更稳
    try {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (e) {
        // ignore
    }
    // 再兜底一次，防止 a.click 被拦截
    setTimeout(() => {
        window.location.href = url;
    }, 100);
};

export const handleIosDownload = () => {
    // 微信内置浏览器会拦截自定义 scheme，且 iframe 唤起后经常导致后续跳市场失败
    // 所以微信里跳过唤起，直接走 App Store
    if (isWeChat()) {
        openAppStore();
        return;
    }

    let timer = null;
    const timeoutDuration = 2000;

    const onVisibilityChange = () => {
        if (document.visibilityState === 'hidden' || document.hidden) {
            cancelFallback();
        }
    };

    const cancelFallback = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', cancelFallback);
        window.removeEventListener('blur', cancelFallback);
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', cancelFallback);
    window.addEventListener('blur', cancelFallback);

    timer = setTimeout(() => {
        cancelFallback();
        openAppStore();
    }, timeoutDuration);

    // Safari 等环境：用隐藏 iframe 尝试唤起 App
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = iosScheme;
    document.body.appendChild(iframe);
    setTimeout(() => {
        if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
        }
    }, 100);
};

// 安卓：根据厂商跳转到对应应用市场，默认小米商店
export const handleAndroidDownload = () => {
    const ua = navigator.userAgent.toLowerCase();
    let targetLink = downloadLinks.xiaomi;

    if (ua.includes('xiaomi') || ua.includes('miui') || ua.includes('redmi')) {
        targetLink = downloadLinks.xiaomi;
    } else if (ua.includes('vivo')) {
        targetLink = downloadLinks.vivo;
    } else if (ua.includes('oppo') || ua.includes('coloros') || ua.includes('realme') || ua.includes('oppobrowser')) {
        targetLink = downloadLinks.oppo;
    } else if (ua.includes('honor') || ua.includes('magic')) {
        targetLink = downloadLinks.honor;
    }

    window.location.href = targetLink;
};

// 鸿蒙/华为应用市场
export const handleHarmonyDownload = () => {
    window.location.href = downloadLinks.harmony;
};

// 统一入口：自动识别当前设备
export const handleDownload = (type) => {
    const resolvedType = type || detectPlatform();
    if (resolvedType === 'ios') {
        handleIosDownload();
    } else if (resolvedType === 'harmony') {
        handleHarmonyDownload();
    } else {
        handleAndroidDownload();
    }
};

export const detectPlatform = () => {
    if (isIos()) return 'ios';
    return 'android';
};
